import * as React from "react";
import { SectionCard } from "../../components/forms/formPrimitives";
import { REFINED } from "../../components/risikoanalyseStep/tokens";
import type { ProfileSectionProps } from "./profileShell";

/**
 * Sektion „Abwesenheiten / Anwesenheiten" (Vorplan §7) — reiner Platzhalter.
 *
 * Bewusst ohne State, ohne API, ohne Migration: SP6 hält nur den ausgegrauten
 * „später"-Zustand. Das echte Feature (Urlaub/Homeoffice/Raum beantragen &
 * einsehen) folgt in einer späteren Story.
 *
 * `sectionRef` wird vom SP1-`ProfilePage`-Wrapper getragen (Scroll-Spy), daher
 * hier — wie bei den übrigen Sektionen — bewusst NICHT erneut angeheftet.
 */
export const ProfileAbwesenheiten: React.FC<ProfileSectionProps> = () => (
  <SectionCard title="ABWESENHEITEN" heading="Abwesenheiten / Anwesenheiten">
    <div style={{ opacity: 0.6, pointerEvents: "none" }}>
      <p
        style={{
          margin: 0,
          fontFamily: REFINED.fontUI,
          color: REFINED.ink2,
          fontSize: "0.95rem",
        }}
      >
        Später: Urlaub, Homeoffice und Raum beantragen &amp; einsehen.
      </p>
    </div>
  </SectionCard>
);

export default ProfileAbwesenheiten;
